import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var TextTranslationService;
(function (TextTranslationService) {
    TextTranslationService.SYMBOL = Symbol.for('TextTranslationService');
})(TextTranslationService || (TextTranslationService = {}));
export default (container) => {
    let TextTranslationServiceImpl = class TextTranslationServiceImpl {
        constructor() {
            Object.defineProperty(this, "cache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Map()
            });
        }
        async entries(name) {
            if (this.cache.has(name))
                return this.cache.get(name);
            const res = await fetch(`/datas/english/text-translation/${encodeURIComponent(name)}.json`);
            if (!res.ok)
                throw new Error(`text-translation not found: ${name}`);
            const data = await res.json();
            this.cache.set(name, data);
            return data;
        }
        clearCache() { this.cache.clear(); }
    };
    TextTranslationServiceImpl = __decorate([
        Sim({ symbol: TextTranslationService.SYMBOL, container: container })
    ], TextTranslationServiceImpl);
    return TextTranslationServiceImpl;
};
